import React, {useEffect, useState, useMemo} from 'react';
import moment from "moment/moment";


interface IComponentProps {
  data: any;
  timeKeyPath: string
}
const TimestampToTimeString: React.FC<IComponentProps> = (props) => {
  const { data, timeKeyPath } = props
  const text = useMemo(() => {
    const arr = timeKeyPath.split('.')
    let value: any = data
    for (let i = 0; i < arr.length; i++) {
      value = value?.[arr[i]]
    }
    return moment(value).format('YYYY-MM-DD HH:mm:ss')
  }, [props])
  return (
    <>
      {text}
    </>
  );
};

export default TimestampToTimeString;
